/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

/**
 * Renders the icon to show when prerequisites are not met.
 * @returns The icon to show when prerequisites are not met.
 */
export const WarningIcon: React.VFC = () => {
    return (
        <svg width="204" height="201" viewBox="0 0 204 201" fill="none" xmlns="https://www.w3.org/2000/svg">
            <g filter="url(#filter0_dd_3426_76253)">
                <path
                    d="M164.49 89.1873L122.499 131.044C120.051 133.464 121.153 137.698 124.581 138.545L182.242 153.666C185.67 154.513 188.73 151.489 187.873 148.102L172.203 91.2439C171.101 87.8566 166.939 86.6469 164.49 89.1873Z"
                    fill="url(#paint0_linear_3426_76253)"
                />
            </g>
            <path
                d="M170.121 117.616C167.551 116.89 166.081 114.108 166.816 111.567L177.344 76.8479C178.079 74.3075 180.895 72.8558 183.466 73.5816C186.036 74.3075 187.505 77.0899 186.771 79.6303L176.12 114.471C175.386 117.011 172.692 118.463 170.121 117.616Z"
                fill="#EEB65C"
            />
            <path
                d="M166.695 134.189C169.737 134.189 172.204 131.752 172.204 128.746C172.204 125.739 169.737 123.302 166.695 123.302C163.652 123.302 161.186 125.739 161.186 128.746C161.186 131.752 163.652 134.189 166.695 134.189Z"
                fill="#EEB65C"
            />
            <path
                d="M42.3124 41.7658L17.3382 95.3572C15.8691 98.5025 18.44 102.011 21.8678 101.769L81.2428 96.325C84.793 95.9621 86.6293 92.0909 84.5482 89.1875L50.1474 41.04C48.0663 38.1366 43.7815 38.6205 42.3124 41.7658Z"
                fill="url(#paint1_linear_3426_76253)"
            />
            <path
                d="M36.0695 75.3964C33.4987 76.1223 30.8054 74.6706 30.0708 72.0092L20.0322 37.0478C19.2977 34.5073 20.7667 31.8459 23.46 31.12C26.0309 30.3942 28.7242 31.8459 29.4587 34.5073L39.4974 69.4687C40.1095 72.0092 38.6404 74.6706 36.0695 75.3964Z"
                fill="#28C2D1"
            />
            <path
                d="M39.2532 91.9699C42.2957 91.9699 44.7622 89.5326 44.7622 86.5261C44.7622 83.5196 42.2957 81.0823 39.2532 81.0823C36.2106 81.0823 33.7441 83.5196 33.7441 86.5261C33.7441 89.5326 36.2106 91.9699 39.2532 91.9699Z"
                fill="#28C2D1"
            />
            <g filter="url(#filter1_dd_3426_76253)">
                <path
                    d="M89.8122 49.2659L17.7053 154.876C13.4206 161.046 17.5829 169.514 25.1731 170.119L153.839 179.071C161.429 179.555 166.694 171.812 163.388 165.038L106.829 50.4757C103.524 43.7012 94.097 43.0963 89.8122 49.2659Z"
                    fill="url(#paint2_linear_3426_76253)"
                />
            </g>
            <path
                d="M92.2602 135.157C89.5669 134.915 87.4857 132.617 87.7305 129.955L91.2808 80.4771C91.5256 77.8157 93.8516 75.7591 96.5449 76.001C99.2382 76.243 101.319 78.5415 101.075 81.2029L97.5243 130.681C97.2795 133.343 94.9534 135.278 92.2602 135.157Z"
                fill="white"
            />
            <path
                d="M91.5266 152.094C94.5691 152.094 97.0356 149.656 97.0356 146.65C97.0356 143.643 94.5691 141.206 91.5266 141.206C88.484 141.206 86.0176 143.643 86.0176 146.65C86.0176 149.656 88.484 152.094 91.5266 152.094Z"
                fill="white"
            />
            <path
                d="M110.501 36.3219C109.767 37.5317 110.012 38.9833 110.991 39.9511C111.113 40.0721 111.358 40.3141 111.603 40.3141C113.072 41.1609 114.909 40.677 115.643 39.3463L119.438 33.0556C119.805 32.3298 119.928 31.6039 119.805 30.7571C119.683 30.1523 119.316 29.5474 118.826 29.1845C118.704 29.0635 118.581 29.0635 118.459 28.9425C116.99 28.0957 115.153 28.5796 114.419 29.9103L110.501 36.3219Z"
                fill="#E1DFDD"
            />
            <path
                d="M122.131 49.7498C122.253 49.9918 122.498 50.3547 122.743 50.5966C123.722 51.4434 125.069 51.6854 126.171 51.0805L132.537 47.9352C133.271 47.5723 133.761 46.9674 134.006 46.2416C134.251 45.5157 134.251 44.6689 133.884 43.9431C133.639 43.5801 133.394 43.2172 133.027 42.9753C132.782 42.7333 132.414 42.6124 132.17 42.4914C131.435 42.2494 130.578 42.2494 129.844 42.6124L123.478 45.7577C122.743 46.1206 122.253 46.7255 122.009 47.4513C121.764 48.2981 121.764 49.024 122.131 49.7498Z"
                fill="#E1DFDD"
            />
            <path
                d="M95.566 33.6604C95.6885 34.2653 95.9333 34.8702 96.423 35.354C97.0351 35.9589 98.0145 36.3218 98.8715 36.2009C100.463 35.9589 101.687 34.5072 101.442 32.8136L100.341 25.0713C100.218 24.3454 99.8508 23.6196 99.2387 23.1357C98.6266 22.6518 97.7697 22.4099 96.9127 22.5308C95.3212 22.7728 94.097 24.2245 94.3418 25.9181L95.566 33.6604Z"
                fill="#E1DFDD"
            />
            <defs>
                <filter
                    id="filter0_dd_3426_76253"
                    x="113.178"
                    y="81.0279"
                    width="82.8418"
                    height="81.9824"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.2" />
                    <feGaussianBlur stdDeviation="4" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3426_76253" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="0.4" />
                    <feGaussianBlur stdDeviation="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
                    <feBlend mode="normal" in2="effect1_dropShadow_3426_76253" result="effect2_dropShadow_3426_76253" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3426_76253" result="shape" />
                </filter>
                <filter
                    id="filter1_dd_3426_76253"
                    x="7.98242"
                    y="38.1929"
                    width="164.412"
                    height="150.099"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.2" />
                    <feGaussianBlur stdDeviation="4" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3426_76253" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="0.4" />
                    <feGaussianBlur stdDeviation="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                    <feBlend mode="normal" in2="effect1_dropShadow_3426_76253" result="effect2_dropShadow_3426_76253" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3426_76253" result="shape" />
                </filter>
                <linearGradient
                    id="paint0_linear_3426_76253"
                    x1="162.654"
                    y1="99.3492"
                    x2="169.23"
                    y2="178.6"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBE5BE" />
                    <stop offset="1" stopColor="#F9D699" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_3426_76253"
                    x1="80.5009"
                    y1="97.9214"
                    x2="46.766"
                    y2="77.4881"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.000984252" stopColor="#7BDDEF" />
                    <stop offset="1" stopColor="#C3F2F4" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_3426_76253"
                    x1="84.3032"
                    y1="103.583"
                    x2="87.8737"
                    y2="213.752"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#BDBEE3" />
                    <stop offset="1" stopColor="#8E91E4" />
                </linearGradient>
            </defs>
        </svg>
    );
};